import { useRef } from 'react';
import { useFormContext } from 'react-hook-form';

import SwitchInput from 'components/field/SwitchInput';
import TimeInput from 'components/field/TimeInput';
import Card from 'components/global/Card';
import Collapse from 'components/global/Collapse';
import Icon from 'components/global/Icon';
import Typography from 'components/global/Typography';

import useMediaQuery from 'hooks/useMediaQuery';

import { Breakpoints } from 'utils/const.styles';

import { faAngleDown } from '@fortawesome/pro-regular-svg-icons';

import * as S from './styled/WorkingHourBox.styled';

export const workingHoursDummyData = [
	{
		status: true,
		day: 'sunday',
		from: '00:00',
		to: '23:59'
	},
	{ status: true, day: 'monday', from: '00:00', to: '23:59' },
	{
		status: true,
		day: 'tuesday',
		from: '00:00',
		to: '23:59'
	},
	{
		status: true,
		day: 'wednesday',
		from: '00:00',
		to: '23:59'
	},
	{
		status: true,
		day: 'thursday',
		from: '00:00',
		to: '23:59'
	},
	{
		status: true,
		day: 'friday',
		from: '00:00',
		to: '23:59'
	},
	{
		status: true,
		day: 'saturday',
		from: '00:00',
		to: '23:59'
	}
];

const WorkingHourBox = ({ data, mode, index }) => {
	const formMethods = useFormContext();
	const { setValue, watch } = formMethods;
	const isMobile = useMediaQuery(Breakpoints.mobile);
	const totalAccordionRef = useRef(null);

	return (
		<Card rounded fullWidth className="mb-3" padding={isMobile ? 1.5 : 1}>
			<S.FlexSpaced>
				<div className="day" ref={isMobile ? totalAccordionRef : undefined}>
					<SwitchInput name={`workingHours[${index}].status`} disabled={mode === 'view'} />
					<Typography fontWeight="500" className="mx-3">
						{data.day}
					</Typography>
					{isMobile && <Icon className="expand-icon" icon={faAngleDown} size="medium" />}
				</div>
				{isMobile ? (
					<Collapse buttonRef={isMobile ? totalAccordionRef : undefined} defaultVisible>
						<div className="hours">
							<Typography className="mx-2 title" noWrap fontWeight="500" color="var(--content-3)">
								from.upperCase
							</Typography>
							<TimeInput
								className="w-100 fromtime"
								name={`workingHours[${index}].from`}
								disabled={mode === 'view' || !watch(`workingHours[${index}].status`)}
								setValue={(value) => {
									setValue(`workingHours[${index}].from`, value, {
										shouldValidate: true,
										shouldDirty: true
									});
								}}
								value={watch(`workingHours[${index}].from`)}
							/>

							<Typography className="mx-3 to" color="var(--content-3)">
								to.upperCase
							</Typography>

							<TimeInput
								className="w-100 totime"
								name={`workingHours[${index}].to`}
								disabled={mode === 'view' || !watch(`workingHours[${index}].status`)}
								setValue={(value) => {
									setValue(`workingHours[${index}].to`, value, {
										shouldValidate: true,
										shouldDirty: true
									});
								}}
								value={watch(`workingHours[${index}].to`)}
							/>
						</div>
					</Collapse>
				) : (
					<div className="hours">
						<Typography className="mx-2" color="var(--content-3)" noWrap>
							from.upperCase
						</Typography>

						<TimeInput
							className="w-100"
							name={`workingHours[${index}].from`}
							disabled={mode === 'view' || !watch(`workingHours[${index}].status`)}
							setValue={(value) => {
								setValue(`workingHours[${index}].from`, value, {
									shouldValidate: true,
									shouldDirty: true
								});
							}}
							value={watch(`workingHours[${index}].from`)}
						/>

						<Typography color="var(--content-3)">to.upperCase</Typography>

						<TimeInput
							className="w-100"
							name={`workingHours[${index}].to`}
							disabled={mode === 'view' || !watch(`workingHours[${index}].status`)}
							setValue={(value) => {
								setValue(`workingHours[${index}].to`, value, {
									shouldValidate: true,
									shouldDirty: true
								});
							}}
							value={watch(`workingHours[${index}].to`)}
						/>
					</div>
				)}
			</S.FlexSpaced>
		</Card>
	);
};

const WorkingHours = ({ mode, workingHoursData }) => (
	<>
		{workingHoursData?.map((data, index) => (
			<WorkingHourBox key={data.id} data={data} mode={mode} index={index} />
		))}
	</>
);

export default WorkingHours;
